function fetchItems(url) {
    const loadMore = $('#load-more');
    const grid = $('.collection-grid .columns');
    const gridWrapper = $('.collection-grid .wrapper');

    // Get new posts
    $.get({
        url: url,
        beforeSend: function() {
            loadMore.addClass('is-pending');
        },
        error: function() {
            loadMore.removeClass('is-pending');
        },
        success: function(data) {
            const newItems = $(data).find('.collection-grid .column');
            const newLoadMore = $(data).find('#load-more');

            // Remove load more
            loadMore.remove();

            // Update post grid
            grid.append(newItems);

            // Append new load more
            gridWrapper.append(newLoadMore);

            // Reinit match heights
            matchHeights();
        },
    });
}

function initPagination() {
    if( !$('#load-more').length ) {
        return false;
    }

    $(document).on('click', '#load-more', function() {
        const url = $(this).data('url');
        fetchItems(url, false);
    });
}

$(document).ready(function() {
    initPagination(); 
});